import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "poi-editor" }
const _hoisted_2 = { class: "editor-layout" }
const _hoisted_3 = { class: "svg-viewer" }
const _hoisted_4 = { class: "svg-controls" }
const _hoisted_5 = { class: "zoom-level" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["viewBox"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["x", "y", "width", "height"]
const _hoisted_10 = ["transform"]
const _hoisted_11 = ["transform"]
const _hoisted_12 = ["y"]
const _hoisted_13 = ["x", "y", "onMousedown"]
const _hoisted_14 = ["x", "y", "onMousedown"]
const _hoisted_15 = {
  key: 0,
  class: "poi-ghost"
}
const _hoisted_16 = ["x", "y", "width", "height"]
const _hoisted_17 = ["transform"]
const _hoisted_18 = ["transform"]
const _hoisted_19 = { class: "side-panel" }
const _hoisted_20 = { class: "poi-list-header" }
const _hoisted_21 = {
  key: 0,
  class: "poi-list"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "poi-thumbnail" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = {
  key: 1,
  class: "poi-thumbnail-placeholder"
}
const _hoisted_26 = { class: "poi-item-info" }
const _hoisted_27 = { class: "poi-item-title" }
const _hoisted_28 = { class: "poi-item-desc" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "poi-empty"
}
const _hoisted_31 = {
  key: 2,
  class: "poi-edit-panel"
}
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = {
  key: 0,
  class: "upload-spinner"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 1,
  class: "image-preview"
}
const _hoisted_38 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "editor-header" }, [
      _createElementVNode("h2", null, "Assign Points of Interest"),
      _createElementVNode("p", null, "Place markers on the map for notable community features like parks, community centres, schools, etc. Each marker has a title, photo, and description.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleZoomIn,
            title: "Zoom In"
          }, "+"),
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleZoomOut,
            title: "Zoom Out"
          }, "−"),
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleResetView,
            title: "Reset View"
          }, "⟲"),
          _createElementVNode("div", _hoisted_5, _toDisplayString(Math.round($setup.zoomLevel * 100)) + "%", 1),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "controls-separator" }, null, -1)),
          _createElementVNode("button", {
            class: _normalizeClass(["btn-add-poi", { active: $setup.isPlacingMode }]),
            onClick: $setup.togglePlacingMode
          }, _toDisplayString($setup.isPlacingMode ? "✗ Cancel Placement" : "+ Add Point of Interest"), 3)
        ]),
        _createElementVNode("div", {
          class: "svg-container",
          ref: "svgContainer",
          style: _normalizeStyle({ cursor: $setup.isPlacingMode ? 'crosshair' : $setup.isDragging ? 'grabbing' : 'grab' }),
          onWheel: _withModifiers($setup.handleWheel, ["prevent"]),
          onMousedown: $setup.handleMouseDown,
          onMousemove: $setup.handleMouseMove,
          onMouseup: $setup.handleMouseUp,
          onMouseleave: $setup.handleMouseLeave,
          onClick: $setup.handleContainerClick
        }, [
          ($setup.svgContent)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "svg-background",
                innerHTML: $setup.svgContent,
                style: _normalizeStyle($setup.svgTransformStyle)
              }, null, 12, _hoisted_6))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("svg", {
            class: "svg-overlay",
            ref: "svgOverlay",
            style: _normalizeStyle($setup.svgTransformStyle),
            viewBox: $setup.overlayViewBox,
            preserveAspectRatio: "xMidYMid meet"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localPois, (poi, index) => {
              return (_openBlock(), _createElementBlock("g", {
                key: index,
                class: _normalizeClass(["poi-group", { 'poi-selected': $setup.selectedIndex === index }]),
                onClick: _withModifiers(($event: any) => ($setup.selectPoi(index)), ["stop"])
              }, [
                _createElementVNode("rect", {
                  class: _normalizeClass(["poi-hit", { 'poi-hit--selected': $setup.selectedIndex === index }]),
                  x: poi.boundingBox.x,
                  y: poi.boundingBox.y,
                  width: poi.boundingBox.width,
                  height: poi.boundingBox.height
                }, null, 10, _hoisted_9),
                _createElementVNode("g", {
                  class: "poi-marker",
                  transform: `translate(${poi.boundingBox.x + poi.boundingBox.width / 2}, ${poi.boundingBox.y + poi.boundingBox.height / 2})`
                }, [
                  _createElementVNode("g", {
                    class: "poi-pin-icon",
                    transform: `translate(${-$setup.getPoiPinSize(poi) / 2}, ${-$setup.getPoiPinSize(poi) / 2}) scale(${$setup.getPoiPinSize(poi) / 24})`
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("path", {
                      class: "poi-pin-outer",
                      d: "M20 10c0 6-8 13-8 13s-8-7-8-13a8 8 0 0 1 16 0Z"
                    }, null, -1),
                    _createElementVNode("circle", {
                      class: "poi-pin-inner",
                      cx: "12",
                      cy: "10",
                      r: "2.5"
                    }, null, -1)
                  ]))], 8, _hoisted_11),
                  _createElementVNode("text", {
                    class: "poi-label",
                    "text-anchor": "middle",
                    "dominant-baseline": "hanging",
                    y: $setup.getPoiPinSize(poi) / 2 + 4,
                    "font-size": "14"
                  }, _toDisplayString(poi.title || "Untitled"), 9, _hoisted_12)
                ], 8, _hoisted_10),
                ($setup.selectedIndex === index)
                  ? (_openBlock(), _createElementBlock("rect", {
                      key: 0,
                      class: "poi-move-handle",
                      x: poi.boundingBox.x + poi.boundingBox.width / 2 - 8,
                      y: poi.boundingBox.y + poi.boundingBox.height / 2 - 8,
                      width: "16",
                      height: "16",
                      rx: "3",
                      onMousedown: _withModifiers(($event: any) => ($setup.startMoving($event, index)), ["stop"])
                    }, null, 40, _hoisted_13))
                  : _createCommentVNode("", true),
                ($setup.selectedIndex === index)
                  ? (_openBlock(), _createElementBlock("rect", {
                      key: 1,
                      class: "poi-resize-handle",
                      x: poi.boundingBox.x + poi.boundingBox.width - 6,
                      y: poi.boundingBox.y + poi.boundingBox.height - 6,
                      width: "10",
                      height: "10",
                      onMousedown: _withModifiers(($event: any) => ($setup.startResizing($event, index)), ["stop"])
                    }, null, 40, _hoisted_14))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_8))
            }), 128)),
            ($setup.ghostRect)
              ? (_openBlock(), _createElementBlock("g", _hoisted_15, [
                  _createElementVNode("rect", {
                    class: "poi-ghost-hit",
                    x: $setup.ghostRect.x,
                    y: $setup.ghostRect.y,
                    width: $setup.ghostRect.width,
                    height: $setup.ghostRect.height
                  }, null, 8, _hoisted_16),
                  _createElementVNode("g", {
                    class: "poi-ghost-marker",
                    transform: `translate(${$setup.ghostRect.x + $setup.ghostRect.width / 2}, ${$setup.ghostRect.y + $setup.ghostRect.height / 2})`
                  }, [
                    _createElementVNode("g", {
                      class: "poi-ghost-icon",
                      transform: `translate(${(-Math.min($setup.ghostRect.width, $setup.ghostRect.height) * 0.75) / 2}, ${(-Math.min($setup.ghostRect.width, $setup.ghostRect.height) * 0.75) / 2}) scale(${(Math.min($setup.ghostRect.width, $setup.ghostRect.height) * 0.75) / 24})`
                    }, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("path", {
                        class: "poi-pin-outer",
                        d: "M20 10c0 6-8 13-8 13s-8-7-8-13a8 8 0 0 1 16 0Z"
                      }, null, -1),
                      _createElementVNode("circle", {
                        class: "poi-pin-inner",
                        cx: "12",
                        cy: "10",
                        r: "2.5"
                      }, null, -1)
                    ]))], 8, _hoisted_18)
                  ], 8, _hoisted_17)
                ]))
              : _createCommentVNode("", true)
          ], 12, _hoisted_7))
        ], 36)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("h3", null, "Points of Interest (" + _toDisplayString($setup.localPois.length) + ")", 1)
        ]),
        ($setup.localPois.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.localPois, (poi, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["poi-list-item", { active: $setup.selectedIndex === index }]),
                  key: index,
                  onClick: ($event: any) => ($setup.selectPoi(index))
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    (poi.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: poi.imageUrl,
                          alt: poi.title
                        }, null, 8, _hoisted_24))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, "📍"))
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(poi.title || "Untitled"), 1),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(poi.description ? poi.description.substring(0, 40) + (poi.description.length > 40 ? "..." : "") : "No description"), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "poi-delete-btn",
                    onClick: _withModifiers(($event: any) => ($setup.deletePoi(index)), ["stop"]),
                    title: "Delete"
                  }, "✕", 8, _hoisted_29)
                ], 10, _hoisted_22))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("p", null, "Click \"+ Add Point of Interest\" then click on the map to place a marker.", -1)
            ]))])),
        ($setup.selectedIndex !== null && $setup.localPois[$setup.selectedIndex])
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Edit Point of Interest", -1)),
              _createElementVNode("div", _hoisted_32, [
                _cache[9] || (_cache[9] = _createElementVNode("label", null, "Title *", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-input",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.localPois[$setup.selectedIndex].title) = $event)),
                  placeholder: "e.g. Community Centre"
                }, null, 512), [
                  [_vModelText, $setup.localPois[$setup.selectedIndex].title]
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[10] || (_cache[10] = _createElementVNode("label", null, "Description", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.localPois[$setup.selectedIndex].description) = $event)),
                  placeholder: "Describe this location...",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, $setup.localPois[$setup.selectedIndex].description]
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Photo", -1)),
                (!$setup.localPois[$setup.selectedIndex].imageUrl)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["image-upload-area", { uploading: $setup.uploadingIndex === $setup.selectedIndex }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.triggerImageUpload($setup.selectedIndex)))
                    }, [
                      ($setup.uploadingIndex === $setup.selectedIndex)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                        : (_openBlock(), _createElementBlock("span", _hoisted_36, "📷 Click to upload photo"))
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("img", {
                        src: $setup.localPois[$setup.selectedIndex].imageUrl,
                        alt: "POI photo"
                      }, null, 8, _hoisted_38),
                      _createElementVNode("button", {
                        class: "remove-image-btn",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.removeImage($setup.selectedIndex)))
                      }, "Remove photo")
                    ])),
                _createElementVNode("input", {
                  ref: (el) => $setup.setImageInputRef(el, $setup.selectedIndex),
                  type: "file",
                  accept: "image/jpeg,image/png,image/webp",
                  style: {"display":"none"},
                  onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.handleImageUpload($event, $setup.selectedIndex)))
                }, null, 544)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", { class: "editor-footer" }, [
      _createElementVNode("button", {
        class: "btn-primary",
        onClick: $setup.handleComplete
      }, "Continue to Preview →")
    ])
  ]))
}